export default __webpack_public_path__ + "static/media/Creative_Industries_Fund_NL_logo.90224a9e.png";